import { Card, Form, Button, InputGroup } from 'react-bootstrap';
import { FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
import swal from 'sweetalert';
import { useContext, useState } from 'react';
import axios from 'axios';
import UserContext from '../../utils/Contexts/UserContext';

const ChangePasswordPage = ({ signOut }) => {
	const [password, setPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [errors, setErrors] = useState({});
	const [visible, setVisible] = useState(false);
	const [visible2, setVisible2] = useState(false);
	const user = useContext(UserContext);

	const validateForm = () => {
		setErrors({});
		let isValid = true;

		if (password === '') {
			setErrors({
				...errors,
				password: 'La contraseña no puede estar vacía',
			});
			isValid = false;
		}
		if (password !== confirmPassword) {
			setErrors({
				...errors,
				confirmPassword: 'Las contraseñas no coinciden',
			});
			isValid = false;
		}

		const regex =
			/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@!%*?&])([A-Za-z\d$@$!%*?&]|[^ ]){8,}$/;
		if (!regex.test(password)) {
			setErrors({
				...errors,
				password:
					'La contraseña debe tener al menos 8 caracteres, una mayúscula, una minúscula, un número y un caracter especial',
			});
			isValid = false;
		}
		return isValid;
	};

	const handleChangePassword = async () => {
		if (validateForm()) {
			const data = {
				email: user.attributes.email,
				newPassword: password,
			};

			await axios.put(
				'https:///8siu8hczc2.execute-api.us-east-1.amazonaws.com/Prod/change-password',
				data
			).then((response) => {
				if (response.status === 200) {
					swal('Contraseña cambiada', 'La contraseña ha sido cambiada', 'success');
					signOut();
				} else {
					swal('Error', 'Ha ocurrido un error', 'error');
				}
			});
		} else {
			swal('Verifique los datos', 'Hay errores en el formulario', 'error');
		}
	};

	return (
		<>

			<div
				style={{
					flex: '1 1 auto',
					display: 'flex',
					flexFlow: 'column',
					height: '100vh',
					width: '100%',
					overflowY: 'hidden'
				}}
			>
				<div
					style={{
						padding: '20px 5%',
						height: '100vh',
						overflowY: 'scroll',
					}}
				>
					{/* Card with a form */}
					{/* Centered container */}
					<div
						style={{
							display: 'flex',
							height: '100%',
							width: '100%',
							justifyContent: 'center',
							alignItems: 'center',
						}}
					>
						<Card
							style={{
								display: 'flex',
								width: '70%',
							}}
						>
							<Card.Header>
								<Card.Title>
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
											gap: '20px',
										}}
									>
										<FaLock size={30} />
										<h1>Cambiar contraseña</h1>
									</div>
								</Card.Title>
							</Card.Header>
							<Card.Body>
								<Form onSubmit={handleChangePassword}>
									<Form.Label htmlFor='basic-url'>Nueva contraseña:</Form.Label>
									<InputGroup className='mb-3'>
										<Form.Control
											type={visible ? 'text' : 'password'}
											placeholder='¿Qué contraseña vamos a usar?'
											value={password}
											onChange={(e) => {
												setPassword(e.target.value);
												delete errors.password;
											}}
											isInvalid={errors.password}
										/>
										<InputGroup.Text
											className='rounded-end'
											onClick={() => {
												setVisible(!visible);
											}}
										>
											{visible ? <FaEyeSlash /> : <FaEye />}
										</InputGroup.Text>
										<Form.Control.Feedback type='invalid'>
											{errors.password}
										</Form.Control.Feedback>
									</InputGroup>

									<Form.Label className='mb-0'>
										Confirmar contraseña:
									</Form.Label>
									<InputGroup>
										<Form.Control
											type={visible2 ? 'text' : 'password'}
											placeholder='Escribe de nuevo la contraseña'
											value={confirmPassword}
											onChange={(e) => {
												setConfirmPassword(e.target.value);
												delete errors.confirmPassword;
											}}
											isInvalid={errors.confirmPassword}
										/>
										<InputGroup.Text
											className='rounded-end'
											onClick={() => {
												setVisible2(!visible2);
											}}
										>
											{visible2 ? <FaEyeSlash /> : <FaEye />}
										</InputGroup.Text>
										<Form.Control.Feedback type='invalid'>
											{errors.confirmPassword}
										</Form.Control.Feedback>
									</InputGroup>
								</Form>
							</Card.Body>
							<Card.Footer>
								<Button
									type='submit'
									style={{
										width: '100%',
										marginTop: '20px',
										marginBottom: '20px',
									}}
									variant='primary'
									onClick={handleChangePassword}
								>
									Cambiar
								</Button>
							</Card.Footer>
						</Card>
					</div>
				</div>
			</div>
		</>
	);
};

export default ChangePasswordPage;
